import { BaseEcomSdkEnumsObj } from "@payair/e-com-common-sdk";
import { getAdditionalInfo } from "@payair/e-com-common-sdk/core/BaseEcomSdk";
import { SamsungPayEventListenerEnumsObj } from "../../enums/SamsungPayEventListenerEnum";
import EventReporterService from "./EventReporterService";
/** @internal */
export var PAYAIR_SAMSUNG_PAY_EVENT_REPORTER_LISTENER = "PAYAIR_SAMSUNG_PAY_EVENT_REPORTER_LISTENER";
/** @internal */
var EventReporter = /** @class */ (function () {
    function EventReporter() {
        var _this = this;
        this.initEventReporterService = function (pspName, transactionId) {
            _this.transactionId = transactionId;
            _this.eventReporterService = new EventReporterService(pspName);
        };
        this.sendEvent = function (eventType, additionalInfo, requestId, sessionId) {
            var eventParams = {
                eventType: eventType,
                additionalInfo: additionalInfo,
                requestId: requestId,
                sessionId: sessionId,
            };
            _this.handleEvent(eventParams);
        };
    }
    EventReporter.prototype.handleEvent = function (eventParams) {
        var samsungPayEvent = {
            //TODO corelationId, srcDpaId???, transactionStatus
            additionalInfo: getAdditionalInfo(eventParams.additionalInfo),
            clientTimestamp: Date.now(),
            eventType: eventParams.eventType,
            requestId: eventParams.requestId,
            transactionId: this.transactionId ? this.transactionId : "",
            sdk: BaseEcomSdkEnumsObj.PAYAIR_SAMSUNG_PAY_SDK,
        };
        if (this.eventReporterService) {
            this.eventReporterService.reportEvent(samsungPayEvent);
        }
        window.dispatchEvent(new CustomEvent(SamsungPayEventListenerEnumsObj.PAYAIR_SAMSUNG_PAY_SDK_LISTENER, { detail: samsungPayEvent }));
    };
    return EventReporter;
}());
export default EventReporter;
